import { connect } from 'react-redux';

import { approveLicense, rejectLicense } from '../actions/license';

import { LicenseDetailNoteForm } from '../components/license-list';

const mapDispatch = {
  approveLicense,
  rejectLicense
};

export default connect(
  null,
  mapDispatch
)(LicenseDetailNoteForm);
